"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionService = void 0;
const tsyringe_1 = require("tsyringe");
const types_1 = require("../types");
const router_1 = require("@keplr-wallet/router");
const foreground_1 = require("./foreground");
let InteractionService = class InteractionService {
    constructor(eventMsgRequester, rng) {
        this.eventMsgRequester = eventMsgRequester;
        this.rng = rng;
        this.waitingMap = new Map();
        this.resolverMap = new Map();
    }
    // Dispatch the event to the frontend. Don't wait any interaction.
    // And, don't ensure that the event is delivered successfully, just ignore the any errors.
    dispatchEvent(port, type, data) {
        if (!type) {
            throw new router_1.KeplrError("interaction", 101, "Type should not be empty");
        }
        const msg = new foreground_1.PushEventDataMsg({
            type,
            data,
        });
        this.eventMsgRequester.sendMessage(port, msg).catch((e) => {
            console.log(`Failed to send the event to ${port}: ${e.message}`);
        });
    }
    waitApprove(env, url, type, data, options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!type) {
                throw new router_1.KeplrError("interaction", 101, "Type should not be empty");
            }
            // TODO: Add timeout?
            const interactionWaitingData = yield this.addDataToMap(type, env.isInternalMsg, data);
            const msg = new foreground_1.PushInteractionDataMsg(interactionWaitingData);
            return yield this.wait(msg.data.id, () => {
                env.requestInteraction(url, msg, options);
            });
        });
    }
    wait(id, fn) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.resolverMap.has(id)) {
                throw new router_1.KeplrError("interaction", 100, "Id is aleady in use");
            }
            return new Promise((resolve, reject) => {
                this.resolverMap.set(id, {
                    onApprove: resolve,
                    onReject: reject,
                });
                fn();
            });
        });
    }
    approve(id, result) {
        if (this.resolverMap.has(id)) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.resolverMap.get(id).onApprove(result);
            this.resolverMap.delete(id);
        }
        this.removeDataFromMap(id);
    }
    reject(id) {
        if (this.resolverMap.has(id)) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.resolverMap.get(id).onReject(new Error("Request rejected"));
            this.resolverMap.delete(id);
        }
        this.removeDataFromMap(id);
    }
    addDataToMap(type, isInternal, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const bytes = new Uint8Array(8);
            const id = Array.from(yield this.rng(bytes))
                .map((value) => {
                return value.toString(16);
            })
                .join("");
            const interactionWaitingData = {
                id,
                type,
                isInternal,
                data,
            };
            if (this.waitingMap.has(id)) {
                throw new router_1.KeplrError("interaction", 100, "Id is aleady in use");
            }
            this.waitingMap.set(id, interactionWaitingData);
            return interactionWaitingData;
        });
    }
    removeDataFromMap(id) {
        this.waitingMap.delete(id);
    }
};
InteractionService = __decorate([
    tsyringe_1.singleton(),
    __param(0, tsyringe_1.inject(types_1.TYPES.EventMsgRequester)),
    __param(1, tsyringe_1.inject(types_1.TYPES.RNG)),
    __metadata("design:paramtypes", [Object, Function])
], InteractionService);
exports.InteractionService = InteractionService;
//# sourceMappingURL=service.js.map